module.exports = "<about></about>\n<parallax-banner></parallax-banner>\n<timeline></timeline>\n<skills></skills> \n<contact></contact>\n"